import { NotificationTypesEnum } from "../enums/NotificationTypesEnum";

export abstract class AppNotification {
    id: number;
    timestamp: Date;
    installationName: string;
    resultCode: number;
    isRead: boolean;
    abstract notificationType: NotificationTypesEnum;

    constructor(data: any) {
        if (data.Id) this.id = data.Id;
        if (data.Timestamp) this.timestamp = data.Timestamp;
        if (data.IsRead != null && data.IsRead != undefined) this.isRead = data.IsRead;
        if (data.InstallationName) this.installationName = data.InstallationName;
        if (data.ResultCode != null && data.ResultCode != undefined) this.resultCode = data.ResultCode;
    }
}
